import { render } from "./SignUpForm.vue.js?vue&type=template&id=16a3dd76&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SignUpForm.vue?vue&type=template&id=16a3dd76&scoped=true"
import script from "./SignUpForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue.scss?vue&type=style&index=0&id=16a3dd76&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SignUpForm.vue?vue&type=style&index=0&id=16a3dd76&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a3dd76"],['__file',"src/Web/scripts/components/auth/SignUpForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16a3dd76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16a3dd76', __exports__)) {
    api.reload('16a3dd76', __exports__)
  }
  
  module.hot.accept("./SignUpForm.vue.js?vue&type=template&id=16a3dd76&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SignUpForm.vue?vue&type=template&id=16a3dd76&scoped=true", () => {
    api.rerender('16a3dd76', render)
  })

}


export default __exports__